import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { session } from './store/session';

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'home', component: () => import('./views/HomeView.vue') },
  { path: '/scan', name: 'scan', component: () => import('./views/ScanView.vue') },
  /**
   * 申诉入口不放进底部导航 —— 它是「卡被别人领了」这个个例的出口，
   * 只从扫卡页跳进来。医生端要尽可能精简，不为堵个例把设计扩面。
   */
  { path: '/appeal', name: 'appeal', component: () => import('./views/AppealView.vue') },
  { path: '/products', name: 'products', component: () => import('./views/ProductsView.vue') },
  {
    path: '/products/:id',
    name: 'product',
    component: () => import('./views/ProductDetailView.vue'),
  },
  { path: '/checkout', name: 'checkout', component: () => import('./views/CheckoutView.vue') },
  { path: '/orders', name: 'orders', component: () => import('./views/OrdersView.vue') },
  {
    path: '/orders/:id',
    name: 'order-detail',
    component: () => import('./views/OrderDetailView.vue'),
  },
  /** 客服通道：每个医生一条，从「我的」或订单详情进 */
  { path: '/service', name: 'service', component: () => import('./views/ServiceView.vue') },
  { path: '/ledger', name: 'ledger', component: () => import('./views/LedgerView.vue') },
  { path: '/addresses', name: 'addresses', component: () => import('./views/AddressesView.vue') },
  { path: '/me', name: 'me', component: () => import('./views/MeView.vue') },
  { path: '/profile', name: 'profile', component: () => import('./views/ProfileView.vue') },
  {
    path: '/profile/edit',
    name: 'profile-edit',
    component: () => import('./views/ProfileEditView.vue'),
  },
  { path: '/tasks', name: 'tasks', component: () => import('./views/TasksView.vue') },
  /** 业务员端：同一个服务号进来，落到地图而不是积分首页 */
  {
    path: '/sales',
    name: 'sales',
    component: () => import('./views/SalesMapView.vue'),
    meta: { sales: true },
  },
  {
    path: '/sales/:id',
    name: 'sales-clinic',
    component: () => import('./views/SalesClinicView.vue'),
    meta: { sales: true },
  },
  /** 积分动效演示：只在开发期挂载，公开、不登录、不写数据 */
  ...(import.meta.env.DEV
    ? [
        {
          path: '/fx-demo',
          name: 'fx-demo',
          component: () => import('./views/FxDemoView.vue'),
          meta: { public: true },
        } satisfies RouteRecordRaw,
      ]
    : []),
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/LoginView.vue'),
    meta: { public: true },
  },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

/** 默认全部需要登录，要公开必须显式标 meta.public —— 和后端守卫一个思路 */
router.beforeEach((to) => {
  if (to.meta.public) return true;
  if (!session.token) {
    return { name: 'login', query: { next: to.fullPath } };
  }
  // 两种人两种落地页，别让业务员拿着 admin token 去撞医生的 /me
  if (to.meta.sales && session.kind === 'doctor') {
    return { name: 'home' };
  }
  if (!to.meta.sales && session.kind === 'sales') {
    return { name: 'sales' };
  }
  return true;
});
